import { useTheme } from 'styled-components'
import styled from 'styled-components'

interface IProps {
  color?: string | undefined
  size?: 'large' | 'small'
}

const SpinnerEl = styled.div<{ $size: string; $color: string }>`
  width: ${({ $size }) => ($size === 'large' ? '36px' : '20px')};
  height: ${({ $size }) => ($size === 'large' ? '36px' : '20px')};
  border: 3px solid transparent;
  border-top-color: ${({ $color }) => $color};
  border-radius: 50%;
  animation: spin 0.8s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

export function Loading({ color, size = 'small' }: IProps) {
  const { colors } = useTheme()

  const indicatorColor = color || colors.text

  return <SpinnerEl $color={indicatorColor} $size={size} />
}
